export default "__VITE_ASSET__CCyqANbH__"